import queryString from 'query-string';
import {matchPath} from 'react-router';
import pathToRegexp from 'path-to-regexp';

/* Constants */
import {
  PLATFORMS,
  ROUTE_CONFIGS,
  PAGE_ROUTE_PATH_MOBILE_ARRAY,
  PAGE_ROUTE_PATH_DESKTOP_ARRAY,
  ROUTE_PATH_MOBILE_ARRAY,
  ROUTE_PATH_DESKTOP_ARRAY,
  PAGES,
} from './routeConstants';
import {CATEGORY_PAGE_ROUTE_PATH_REGEX} from '../../modules/category/categoryConstants'
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants'
import {FACET_QUERY_PARAM_NAMES} from '../../views/filter/facet/facetConstants'
import {QUERY_STRING_PREFIX} from '../../common/url/urlConstants'

/* Utils */
import {
  generateQueryString,
  generateSearchUrl,
  removeQueryStringFromUrl,
} from '../../common/url/urlUtils'
import {isCollectionPageCheck} from '../../routes/utils/helper';
import {isHurlyPage} from '../../utils/hurlyHelper';

function generateUrlFromRoutePath(routePath, pathParams, queryParams, queryParamOptions) {
  let path;
  let toPath = pathToRegexp.compile(routePath);
  try {
    if (pathParams) {
      path = toPath(pathParams);
    } else {
      path = toPath();
    }
  } catch (e) {
    return;
  }

  if (queryParams && queryParams[FACET_QUERY_PARAM_NAMES.QUERY]) {
    path += QUERY_STRING_PREFIX + generateSearchUrl(
      generateQueryString(
        {
          ...queryParams,
          [PAGINATION_PARAM_NAMES.QUERY]: null,
        },
        {
          ...queryParams,
          withPrefix: false,
        },
      ), queryParams);
  } else {
    if (routePath.substr(1) === CATEGORY_PAGE_ROUTE_PATH_REGEX && queryParams && queryParams[PAGINATION_PARAM_NAMES.CATEGORY]) {
      queryParams[PAGINATION_PARAM_NAMES.CATEGORY] = null
    }
    path += generateQueryString(queryParams, queryParamOptions);
  }

  return path;
}

function extractQueryParamsFromLocation({location, serverContext, isCollectionPage, isHurlyActive}) {
  const result = queryString.parse(location.search);

  if (isHurlyActive && isCollectionPage && isHurlyPage(location?.pathname)) {
    const {queryParams} = serverContext;

    return {
      ...queryParams,
      [PAGINATION_PARAM_NAMES.PAGE]: result?.[PAGINATION_PARAM_NAMES.PAGE] || 1,
    }
  } else if (isCollectionPageCheck({url: location?.path})) {
    return {
      ...result,
      q: serverContext?.queryParams?.q
    }
  }

  return result;
}

function matchUrlForRoutePath(path, routePath, platform = PLATFORMS.MOBILE) {
  let result = null,
    routeConfig = null;

  if (platform === PLATFORMS.MOBILE) {
    routeConfig = ROUTE_CONFIGS[PLATFORMS.MOBILE][routePath];
  } else {
    routeConfig = ROUTE_CONFIGS[PLATFORMS.DESKTOP][routePath];
  }

  const rawMatchPathResult = matchPath(
    removeQueryStringFromUrl(path),
    {
      path: routePath,
      routePath: routePath,
      ...routeConfig,
    }
  );

  if (rawMatchPathResult) {
    result = {
      ...rawMatchPathResult,
      ...routeConfig,
    };
  }

  return result;
}

function matchUrlInRouteArray(path, routeArray, platform = PLATFORMS.MOBILE) {
  let result = null;

  for (let index = 0; index < routeArray.length; index++) {
    const routePath = routeArray[index];
    const matchResult = matchUrlForRoutePath(path, routePath, platform);

    if (matchResult) {
      result = matchResult;
      break;
    }
  }

  return result;
}

function isCollectionPageRouting({nextRoute, currentRoute}) {
  if (nextRoute?.routeName === PAGES.COLLECTION_PAGE && currentRoute?.routeName === PAGES.SEARCH_PAGE) {
    return true;
  }
  if (nextRoute?.routeName === PAGES.SEARCH_PAGE && currentRoute?.routeName === PAGES.COLLECTION_PAGE) {
    return true;
  }

  return false;
}

function matchUrlInRouteConfigs(path, platform = PLATFORMS.MOBILE) {
  const isMobile = platform === PLATFORMS.MOBILE;
  return matchUrlInRouteArray(path, isMobile ? ROUTE_PATH_MOBILE_ARRAY : ROUTE_PATH_DESKTOP_ARRAY, platform);
}

function matchUrlInPageRoutes(path, platform = PLATFORMS.MOBILE) {
  const isMobile = platform === PLATFORMS.MOBILE;
  return matchUrlInRouteArray(path, isMobile ? PAGE_ROUTE_PATH_MOBILE_ARRAY : PAGE_ROUTE_PATH_DESKTOP_ARRAY, platform);
}

export {
  generateUrlFromRoutePath,
  extractQueryParamsFromLocation,
  matchUrlInRouteConfigs,
  matchUrlInRouteArray,
  matchUrlForRoutePath,
  matchUrlInPageRoutes,
  isCollectionPageRouting,
};
